/* eslint-disable react-hooks/rules-of-hooks */
import { useUserState } from 'app/store/user/state';
export const selectUserData = () => useUserState((state) => state.userData);
export const selectIsGettingUser= () => useUserState((state) => state.isLoading);
export const selectIsCartHasProducts= () => useUserState((state) => state.isCartHasProducts);
export const selectProductsInCartQuantity= () => useUserState((state) => state.cartQuantity);
export const selectIsEmailVerified = () => useUserState((state) => state.isEmailVerified);
